<template>
  <div
    class="header-wrap"
    ref="headerWrap"
    :class="{ 'open-menus-wrap': isOpenMenu, 'scrolled-top': isScrollTop }"
  >
    <div class="header-content">
      <div class="logo-wrap">
        <img src="/static/images/logo.png" alt="" class="logo" />
      </div>
      <div ref="headerMenu" :class="$global.isMobile ? 'mobile-menus' : 'menu'">
        <ul>
          <li v-for="(menu, index) in navList" :key="menu.name">
            <div class="menu-title">
              <a
                :href="menu.path"
                :target="menu.path.indexOf('http') > -1 ? '_blank' : '_self'"
                @click="closeMenu"
                >{{ menu.name }}</a
              >
            </div>
          </li>
        </ul>
      </div>
      <div class="login-btns" v-if="!$global.isMobile">
        <div class="btn" @click="goPage('/field')">登录</div>
        <div class="btn signup" @click="openFreeTrial">注册</div>
      </div>
    </div>
    <div
      class="menu-icon"
      :class="{ 'close-btn': isOpenMenu }"
      @click="isOpenMenu = !isOpenMenu"
      v-if="$global.isMobile"
    >
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>
<script>
const Hash = "https://www.changjing.com.cn";
export default {
  props: [],
  data() {
    return {
      navList: [
        { name: "业务价值", path: "#worth" },
        { name: "智能引擎", path: "#engine" },
        // { name: "智能分区", path: "#district" },
        { name: "功能介绍", path: "#function" },
        { name: "产品优势", path: "#advantage" },
        { name: "亿景官网", path: Hash }
      ],
      isOpenMenu: false,
      isScrollTop: false
    };
  },
  methods: {
    goPage(path) {
      if (path === this.$route.path) return;
      this.$router.push(path);
    },
    openFreeTrial() {
      this.$emit("openFreeTrial");
    },
    handleScroll() {
      let windowScrollTop = this.$refs["headerWrap"].parentNode.scrollTop;
      // document.documentElement.scrollTop || document.body.scrollTop;
      this.isScrollTop = windowScrollTop >= 240;
    },
    closeMenu() {
      setTimeout(() => {
        this.isOpenMenu = false;
      }, 200);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  }
};
</script>
<style lang="scss">
@import "../assets/stylesheets/config.scss";

.header-wrap {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
  @include mediastyle(
    (
      height: 100px,
      line-height: 100px
    )
  );

  .header-content {
    overflow: hidden;
    height: 100%;
    margin: 0 auto;
    @include wrap_width;

    .logo-wrap {
      height: 100%;
      float: left;
      img.logo {
        height: 100%;
        float: left;
      }
      .sub-title {
        float: left;
        color: #ffffff;
        font-weight: bold;
        @include mediastyle(
          (
            margin-left: 20px,
            font-size: 30px
          )
        );
      }
    }

    .menu {
      & > ul {
        float: left;
        height: 100%;
        @include mediastyle(
          (
            margin-left: 20px
          )
        );

        & > li {
          box-sizing: content-box;
          height: 100%;
          float: left;
          margin: 0;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          cursor: pointer;
          position: relative;
          font-size: 16px;
          @include mediastyle(
            (
              margin-left: 24px,
              margin-right: 24px
            )
          );
          .menu-title {
            a,
            span {
              color: rgba(255, 255, 255, 1);
              font-size: 16px;
            }
            @media screen and (max-width: 1440px) {
              a,
              span {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
    .login-btns {
      float: right;
      @include mediastyle(
        (
          padding-top: 30px
        )
      );
      .btn {
        float: left;
        text-align: center;
        padding: 0;
        color: #fff;
        font-weight: 600;
        background-color: rgba(255, 255, 255, 0.33);
        cursor: pointer;
        font-size: 14px;
        @include mediastyle(
          (
            height: 40px,
            line-height: 40px,
            padding-left: 36px,
            padding-right: 36px,
            border-radius: 20px
          )
        );
        &:not(:last-of-type) {
          @include mediastyle(
            (
              margin-right: 10px
            )
          );
        }
        &.signup {
          background-color: transparent;
          border: 1px solid rgba(255, 255, 255, 0.33);
        }
      }
    }
  }

  .mobile-menus {
    position: fixed;
    top: 0;
    right: 0;
    width: 0;
    height: 100%;
    padding-top: 10rem;
    transition: width 0.4s;
    overflow: hidden;
    background: #333;
    z-index: 999;
    .wrap {
      padding: 0 0.24rem 0 0.3rem;
    }
    .mobile-menus-top {
      height: 1.06rem;
      width: 100%;
      top: 0;
      left: 0;
    }
    & > ul {
      height: calc(100% - 1.1rem);
      overflow: auto;
      & > li {
        .menu-title {
          height: 6rem;
          font-size: 1.8rem;
          font-weight: 600;
          line-height: 6rem;
          color: #fff;
          padding: 0 6rem 0 3rem;
          a {
            display: block;
            width: 100%;
            height: 100%;
            color: #fff;
          }
        }
      }
    }
    .icon-expand {
      width: 4.4rem;
      height: 4.4rem;
      float: right;
      margin-top: 0.8rem;
      display: block;
      background: url("/images/icon_expand@2x.png");
      background-size: 100% 100%;
      transform: rotate(0deg);
      transition: 0.3s;
    }
    .icon-noexpand {
      transform: rotate(-90deg);
    }
  }
  // mobile
  .menu-icon {
    width: 2rem;
    height: 1.5rem;
    position: fixed;
    top: 2.4rem;
    right: 3rem;
    transition: 0.3s;
    z-index: 9999;
    span {
      display: block;
      position: absolute;
      width: 100%;
      height: 0.2rem;
      background: #fff;
      border-radius: 0.2rem;
      opacity: 1;
      left: 0;
      transform: rotate(0);
      transition: 0.25s ease-in-out;
      z-index: 9;
      &:nth-child(1) {
        top: 0;
      }
      &:nth-child(2),
      &:nth-child(3) {
        top: 50%;
        margin-top: -0.1rem;
      }
      &:nth-child(4) {
        top: 100%;
        margin-top: -0.1rem;
      }
    }
  }
  .close-btn {
    span {
      &:nth-child(1),
      &:nth-child(4) {
        top: 50%;
        width: 0%;
        left: 50%;
        margin-top: -0.1rem;
      }
      &:nth-child(2) {
        transform: rotate(45deg);
      }
      &:nth-child(3) {
        transform: rotate(-45deg);
      }
    }
  }
}
.scrolled-top {
  .menu-icon {
    &:after {
      content: "";
      position: absolute;
      left: -1.4rem;
      top: -1.6rem;
      width: 4.8rem;
      height: 4.8rem;
      background: rgba(178, 178, 178, 0.8);
      border-radius: 50%;
    }
  }
}
.open-menus-wrap {
  .header-content {
    .logo-wrap {
      position: fixed;
      top: 0;
      left: 3rem;
      z-index: 9999;
      height: 6.4rem;
      line-height: 6.4rem;
    }
  }
  .menu-icon {
    &:after {
      display: none;
    }
  }
  .mobile-menus {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue